<template>
  <div id="introduction">
      <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
      <usc-intro :copy="this.intro">
        <h2>Congratulations on Your Admission</h2>
      </usc-intro>
      <div class="body mb gutter-lg">
        <p>We’ve developed this site with resources and information that will help you get to know Marshall better — and introduce you to the life-changing and career-shaping opportunities that are only available here.</p>
        <p><i style="">As a Marshall undergraduate, you will be able to take four full years of business classes, building foundational knowledge and in-demand skills sought by employers. All Marshall programs are STEM-designated — a recognition of the technology and quantitative focus of our curriculum and a signal to employers that our graduates will be well-prepared for tomorrow’s demanding careers. Our nine emphases — optional, industry-driven specializations — let you personalize your degree and will help set you apart in the marketplace. Taking advantage of USC’s status as a world-class private research university, Marshall also gives you ample opportunity to explore your interests across disciplines in USC’s other top-ranked schools.</i></p>
        <p>Double major or select one of our joint degrees — including the groundbreaking Artificial Intelligence for Business program, the renowned John H. Mitchell Business of Cinematic Arts program and the brand-new Real Estate Finance + Development program. You can also pick a minor — or multiple minors — or choose from a huge range of electives across the university to customize your education and meet your professional aspirations.</p>
        <p>All of this and more is why Poets&Quants ranks Marshall the world’s top undergraduate business school.</p>
        <img src="../../static/welcome-infinite-possibility-24.png" alt="Infographic: 16k Degree Combinations, 200+ Majors, and 250+ Minors." title="Infographic: 16k Degree Combinations, 200 Majors, and 220+ Minors." style="width: 100%;"/>
        <p>As you map out your unique educational path, you will gain a world of opportunity, literally. The vast major of Marshall freshmen participate in one of our innovative global offerings, obtaining an international perspective and invaluable skill set.</p>
        <p>Our home in Los Angeles is another distinct advantage. This international financial hub and creative capital of the world is known for its pioneering spirit and leadership in entertainment, business startups, real estate and technology — but it also offers countless ways to enjoy your downtime. With the USC campus just a few miles from legendary beaches and a booming downtown, you will never want for activities or fun in the sun. And yes, some of our best beach days are in February.</p>
        <p>You’ll make lifelong friends and mentors at Marshall. The minute you enroll, you’re a Trojan. And that’s a big deal. You join an unparalleled alumni network that will hire you, promote you, connect you and celebrate with you for the rest of your life.</p>
      </div>
      <usc-calloutLink :url="this.calloutLink.url" :urltext="this.calloutLink.urlText"></usc-calloutLink>
      <div class="body mb gutter-lg">
      <h2>Lifelong, Worldwide</h2>
      <img src="../../static/welcome-lifelong-worldwide-24.png" alt="Infographic: 478k+ Global Alumni, 91k+ Marshall Alumni, 145 Countries, 1/3 Marshall alumni under the age of 35" title="Infographic: 463k+ Global Alumni, 91k+ Marshall Alumni, 145 Countries, 1/3 Marshall alumni under the age of 35" style="width: 100%;"/>
      <p>We look forward to getting to know you better, learning about your passions and goals — and helping you on your path to fulfilling your dreams. This guide is just the beginning of the collaborative process of your journey at USC Marshall. We hope to have many conversations with you and your family as you finalize your college decision. Reach out to us directly at any time at <a href="mailto:busadm@marshall.usc.edu" class="inline-hyperlink">busadm@marshall.usc.edu</a>.</p>
      </div>
      <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
  </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import videoEmbed from '@/components/videoEmbed'
import calloutLink from '@/components/CalloutLink'

export default {
  name: 'Welcome',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-videoEmbed': videoEmbed,
    'usc-calloutLink': calloutLink
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Welcome',
        loResSrc: '../../static/blur/Welcome-Marshall147.jpg',
        hiResSrc: '../../static/HeroImages/Marshall147.jpg'
      },
      intro: [
        'Welcome to the Trojan Family! Being admitted to USC Marshall, one of the world’s top comprehensive business schools, is a recognition of your academic skill, personal achievement and potential for leadership. Congratulations on your admission. You’ve earned this!'
      ],
      video: {
        caption: 'Dean Geoffrey Garrett',
        src: 'https://player.vimeo.com/video/746951106',
        frameTitle: 'Video: Undergraduate Innovation'
      },
      calloutLink: {
        title: 'Accept my offer',
        url: 'https://applyto.usc.edu/apply/status',
        urlText: 'Count me in!'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Welcome', 'Congratulations')
  }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Welcome.vue